import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalDocuments: number
  filename: string
  loading: boolean
  onSubmit: () => void
  onClose: () => void
}

const RestoreModal = ({ totalDocuments, loading, filename, onSubmit, onClose }: Props) => {
  return (
    <Modal
      title={i18n.tp('documents.trash_bin.restore.title', { count: totalDocuments })}
      description={i18n.tp('documents.trash_bin.restore.description', {
        count: totalDocuments,
        name: filename,
      })}
      illustration="history"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button
            type="negative"
            submit
            loading={loading}
            iconName={loading ? 'delete' : undefined}
          >
            {i18n.t('documents.trash_bin.restore.confirm')}
          </Button>
        </>
      }
    />
  )
}

export default RestoreModal
